import { StudyPlanTemplateActivities } from '@/models/kingslanding/studyPlanTemplateActivities';
import { Activity, ActivityType, Lesson } from '@/models/kingslanding/studyPlanModel';
import { formatDate } from '@/helpers/date';

export const groupActivitiesByDate = (
  studyPlanActivities: StudyPlanTemplateActivities[],
  week: number,
) => {
  const activitiesByDate = new Map<string, Activity[]>();

  studyPlanActivities.forEach((activity: StudyPlanTemplateActivities) => {
    if (activity.week !== week) return;

    const date = formatDate(activity.startDateTime, 'DD/MM');

    if (!activitiesByDate.has(date)) {
      activitiesByDate.set(date, []);
    }

    const activities = activitiesByDate.get(date)!;
    const lesson: Lesson = { ...activity, type: ActivityType.lesson };
    activities.push(lesson);
  });

  return activitiesByDate;
};
